import styled from 'styled-components';
import { PanelProvider } from 'utils/panelContext';
import { Row } from 'antd';
import { getPreviewPanel } from 'utils/panelUtils';

const BlockDiv = styled.div`
  margin-bottom: 0.5cm;
  padding-bottom: 0.5cm;
  border-bottom: 1px solid #dddde3;
  &.selectedPanel {
    border: 1px solid #1890ff;
    padding: 6px;
    margin-bottom: 2px;
    margin-top: 2px;
    box-sizing: border-box;
    border-top-width: 1.02px;
    border-radius: 4px;
    outline: none;
    margin-left: -6px;
  }
  overflow-wrap: anywhere;
`;

const BlockHeader = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: #004190;
`;

export const PreviewBlock = ({ step, panel, title, currentPanel, children }) => (
  <BlockDiv className={panel === getPreviewPanel(currentPanel) ? 'selectedPanel' : ''}>
    <BlockHeader>{title}</BlockHeader>
    <PanelProvider
      value={{
        step: step,
        panel: panel
      }}
    >
      <Row>{children}</Row>
    </PanelProvider>
  </BlockDiv>
);
